<template>
  <el-main class="iDalgo-Templates">

    <!-- Template title -->
    <el-row :gutter="20">
      <h2>{{ $t('iDalgoLists.title') }}</h2>
    </el-row>
    <div class="mrg-20"></div>

    <!-- template options -->
    <el-row class="templates-action card">
      <el-col :span="3" :offset="1"><span>{{ $t('iDalgoLists.optionDate') }}</span></el-col>
      <el-col :span="4"><span>{{ $t('iDalgoLists.optionUsers') }}</span></el-col>
      <el-col :span="12" class="col-search"><span>
        <i-dalgo-template-search/>
      </span></el-col>
      <el-col :span="4"><span></span></el-col>
    </el-row>
    <div class="mrg-20"></div>

    <!-- templates -->
    <div v-loading="loading">
      <i-dalgo-template-item v-for="(template, key) in templates" :key="key" :template="template" />
    </div>
    <div class="mrg-20"></div>

    <!-- no template -->
    <el-row v-if="pagination.totalItems === 0 && !$route.query.search">
      <el-col :span="24" style="justify-content: center;">
        <div style="text-align: center;">
          <b>{{ $t('iDalgoLists.noDataInfo') }}</b><br>
          <h2>{{ $t('iDalgoLists.noDataCTA') }}</h2><br>
          <i-dalgo-button @click="handleNewTemplate" :border="true">+ {{ $t('actions.newButton') }}</i-dalgo-button>
        </div>
      </el-col>
    </el-row>
    <el-row v-else-if="pagination.totalItems === 0">
      <el-col :span="24" style="justify-content: center;">
        <div style="text-align: center;">
          <b>{{ $t('iDalgoListEdit.playersModule.resultList.noResult') }}</b><br>
        </div>
      </el-col>
    </el-row>

    <!-- pagination -->
    <el-pagination
      v-if="pagination.totalItems > 0"
      background
      layout="prev, pager, next"
      :page-size="pagination.itemsPerPage"
      :current-page="pagination.currentPage"
      :total="pagination.totalItems"
      @current-change="handlePagination">
    </el-pagination>
  </el-main>

</template>

<script>
import { mapGetters } from 'vuex'
import iDalgoTemplateItem from '@/components/iDalgo-Template-Item'
import iDalgoButton from '@/components/iDalgo-Button'
import iDalgoTemplateSearch from '@/components/iDalgo-Template-Search'
import '@/components/icons'

export default {
  name: 'iDalgo-Templates',
  components: {
    iDalgoTemplateItem,
    iDalgoButton,
    iDalgoTemplateSearch
  },
  computed: {
    ...mapGetters({
      templates: 'templates/templates',
      pagination: 'templates/pagination',
      loading: 'templates/isLoading'
    })
  },
  data () {
    return {}
  },
  methods: {
    handlePagination (val) {
      this.$router.push({ name: 'templates', query: { page: val, search: this.$route.query.search } })
    },
    handleNewTemplate () {
      this.$router.push({ name: 'newTemplate' })
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.$store.dispatch('templates/getTemplates', to.query)
    next()
  },
  async mounted () {
    // get the list of templates of the current page
    if (this.$route.query.page) {
      // use the query in the route
      await this.$store.dispatch('templates/getTemplates', this.$route.query)
      await this.$store.dispatch('templates/getTemplatesStats')
        .catch(() => {
          this.error = true
        })
    } else {
      // no query exists in the route, so push the default route
      this.$router.push({name: 'templates', query: { page: 1 }})
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-size: 40px;
  font-family: 'robotobold';
  margin: 0;
  color: $color1;
}

.templates-action {
  color: $logo-gray;
  font-family: 'robotobold';
  font-size: 14px;
}
</style>

<style lang="scss">
  .iDalgo-Templates {
    .iDalgo-Button {
      .el-button {
        font-size: 18px;
        padding: $default_padding $default_padding * 2;
      }
    }
    .col-search {
      padding: 5px;
      input {
        padding-left: 51px;
        border: none;
        height: 38px;
        width: 413px;
        border-radius: 8px;
        background-color: #FFFFFF;
        box-shadow: inset 0 1px 3px 0 rgba( 0, 0 ,0 ,0.08 );
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/iDalgo-Templates.vue